import React from "react";
import { ProjectState } from "./project";

type ProjectsContextState = {
  projects: ProjectState[];
  setCurrentProject: (projectState: ProjectState) => void;
};

export const ProjectsContext = React.createContext({} as ProjectsContextState);
